import { useTranslation } from 'react-i18next'
import { useFormContext } from '../../../../../../core/providers/FormProvider'
import QuestionSliderSettingRow from '../../components/inputs/QuestionSliderSettingRow'

const OptionSettings: React.FC = () => {
  const { t } = useTranslation()
  const {
    question: [question],
    updateQuestion,
  } = useFormContext()

  const options = question?.__settings?.options

  if (!options) return null

  return (
    <>
      {Object.entries(options)
        .filter(([, value]) => value !== undefined)
        .map(([property, value]) => (
          <QuestionSliderSettingRow
            key={`${question.__uuid}-label-settings-${property}`}
            title={t(`forms.settings.options.${property}`)}
            description={t(`forms.settings.options.${property}_description`)}
            onChange={() => updateQuestion({ __settings: { options: { [property]: !value } } })}
            checked={value}
          />
        ))}
    </>
  )
}

export default OptionSettings
